<template lang="pug">
#modal-editar-operacao-cda-wa
    el-dialog(
        title='Editar operação',
        width='80%',
        :visible='mostrar',
        @close='fechar',
        destroy-on-close
    )
        el-form(
            :model='novosDados',
            label-position='top',
            :rules='validacoes',
            ref='formEditarOperacaoCdaWa'
        )
            .modal-editar-operacao-cda-wa--linha
                el-form-item(label='Identificador', prop='identificador')
                    el-input(
                        v-model='novosDados.identificador',
                        :suffix-icon='validando.identificador ? "el-icon-loading" : ""',
                        :disabled='validando.identificador'
                    )

                el-form-item(label='Descrição', prop='descricao')
                    el-input(v-model='novosDados.descricao')

                el-form-item(label='Volume', prop='volumeContratado')
                    el-input(v-model='novosDados.volumeContratado')

                el-form-item(label='Safra', prop='safra')
                    el-select(v-model='novosDados.idSafra', filterable)
                        el-option(
                            v-for='safra in safras',
                            :label='safra.descricao',
                            :value='safra.id',
                            :key='safra.descricao'
                        )

                el-form-item(label='Cultura', prop='cultura')
                    el-select(v-model='novosDados.idCultura', filterable)
                        el-option(
                            v-for='cultura in culturas',
                            :label='cultura.nome',
                            :value='cultura.id',
                            :key='cultura.codigo'
                        )

            .modal-editar-operacao-cda-wa--linha
                el-form-item(label='Nome do fornecedor', prop='fornecedorNome')
                    el-select(
                        v-model='novosDados.idFornecedor',
                        filterable,
                        remote,
                        :remote-method='buscarFornecedores',
                        :loading='buscandoFornecedores'
                    )
                        el-option(
                            v-for='fornecedor in fornecedores',
                            :key='fornecedor.documento',
                            :label='fornecedor.nome',
                            :value='fornecedor.id'
                        )
                            b {{ fornecedor.nome }}
                            |
                            | ({{ fornecedor.documento }})

                el-form-item(
                    label='Documento do fornecedor',
                    prop='fornecedorDocumento'
                )
                    el-select(
                        v-model='novosDados.idFornecedor',
                        filterable,
                        remote,
                        :remote-method='buscarFornecedores',
                        :loading='buscandoFornecedores'
                    )
                        el-option(
                            v-for='fornecedor in fornecedores',
                            :key='fornecedor.documento',
                            :label='fornecedor.documento',
                            :value='fornecedor.id'
                        )
                            b {{ fornecedor.documento }}
                            |
                            | ({{ fornecedor.nome }})

                el-form-item(label='Data do contrato', prop='dataContrato')
                    el-date-picker(
                        v-model='novosDados.dataContrato',
                        format='dd/MM/yyyy'
                    )

                el-form-item(label='Vencimento', prop='dataVencimento')
                    el-date-picker(
                        v-model='novosDados.dataVencimento',
                        format='dd/MM/yyyy'
                    )

            .modal-editar-operacao-cda-wa--linha
                el-form-item(label='Observação', prop='observacao')
                    el-input(v-model='novosDados.observacao')

                el-form-item(label='Valor', prop='valor')
                    el-input(v-model='novosDados.valor')

                el-form-item(label='Nome do armazém', prop='nomeArmazem')
                    el-input(v-model='novosDados.nomeArmazem')

                el-form-item(
                    label='Documento do armazém',
                    prop='documentoArmazem'
                )
                    el-input(v-model='novosDados.documentoArmazem')

        .buttons.d-flex.justify-content-between(scope='footer')
            BaseButton(size='medium', @click='fechar()') Fechar
            BaseButton(type='primary', size='medium', @click='salvarEdicao') Salvar edição
</template>

<script>
import OperacaoCdaWaService from '@/services/OperacaoCdaWaService';
import RepresentanteService from '@/services/RepresentanteService';
import { sortBy } from 'lodash';
import formatters from '@/utils/formatters';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalEditarOperacaoCdaWa',

    components: {
        BaseButton
    },

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        operacao: {
            type: Object,
            required: true
        },

        safras: {
            type: Array,
            required: true
        },

        culturas: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            novosDados: {
                identificador: '',
                descricao: '',
                volumeContratado: '',
                idSafra: '',
                idCultura: '',
                idFornecedor: '',
                dataContrato: '',
                dataVencimento: '',
                observacao: '',
                valor: '',
                nomeArmazem: '',
                documentoArmazem: ''
            },

            buscandoFornecedores: false,
            fornecedores: [],

            validando: {
                identificador: false
            },

            validacoes: {
                identificador: [
                    {
                        required: true,
                        message: 'Informe um identificador',
                        trigger: 'blur'
                    },
                    {
                        validator: this.validarIdentificador,
                        trigger: 'blur'
                    }
                ],
                descricao: [
                    {
                        required: true,
                        message: 'Informe uma descrição',
                        trigger: 'blur'
                    }
                ],
                volumeContratado: [
                    {
                        required: true,
                        message: 'Informe um volume',
                        trigger: 'blur'
                    }
                ],
                safra: [
                    {
                        required: true,
                        message: 'Selecione uma safra',
                        trigger: 'blur'
                    }
                ],
                cultura: [
                    {
                        required: true,
                        message: 'Selecione uma cultura',
                        trigger: 'blur'
                    }
                ],
                fornecedorNome: [
                    {
                        required: true,
                        message: 'Selecione um fornecedor',
                        trigger: 'blur'
                    }
                ],
                fornecedorDocumento: [
                    {
                        required: true,
                        message: 'Selecione um fornecedor',
                        trigger: 'blur'
                    }
                ],
                dataContrato: [
                    {
                        type: 'date',
                        required: true,
                        message: 'Selecione uma data',
                        trigger: 'blur'
                    },
                    {
                        validator: this.validarDataContrato,
                        trigger: 'blur'
                    }
                ],
                dataVencimento: [
                    {
                        type: 'date',
                        required: true,
                        message: 'Selecione uma data',
                        trigger: 'blur'
                    },
                    {
                        validator: this.validarDataVencimento,
                        trigger: 'blur'
                    }
                ]
            }
        };
    },

    watch: {
        mostrar: async function () {
            if (this.mostrar) {
                if (!Object.keys(this.safras).length) {
                    this.$emit('atualizarSafras');
                }
                if (!Object.keys(this.culturas).length) {
                    this.$emit('atualizarCulturas');
                }

                await this.buscarFornecedores(
                    this.operacao.fornecedorDocumento.replace(/\D/g, '')
                );

                this.novosDados = {
                    idFornecedor: this.fornecedores[0].id,
                    ...this.operacao
                };

                const formatarData = dataFormatoPtBr => {
                    const data = dataFormatoPtBr.split('/');
                    return new Date(data[2] + '/' + data[1] + '/' + data[0]);
                };

                this.novosDados.dataContrato = formatarData(
                    this.novosDados.dataContrato
                );

                this.novosDados.dataVencimento = formatarData(
                    this.novosDados.dataVencimento
                );
            }
        },

        'novosDados.volumeContratado': function () {
            this.novosDados.volumeContratado = this.novosDados.volumeContratado
                .toString()
                .replace(/[^0-9.,]/g, '');
        },

        'novosDados.valor': function () {
            this.novosDados.valor = this.novosDados.valor
                .toString()
                .replace(/[^0-9.,]/g, '');
        }
    },

    methods: {
        fechar() {
            this.$emit('fechar');
        },

        async validarIdentificador(_, valor, mensagem) {
            this.validando.identificador = true;
            try {
                const { data: identificadorEmUso } =
                    await OperacaoCdaWaService.verificarSeIdentificadorEmUso(
                        valor
                    );

                if (
                    identificadorEmUso &&
                    this.operacao.identificador !== valor
                ) {
                    return mensagem(
                        new Error('Este identificador já está em uso')
                    );
                }

                return mensagem();
            } catch (erro) {
                return mensagem(
                    new Error(
                        'Não possível foi verificar se o identificador está em uso'
                    )
                );
            } finally {
                this.validando.identificador = false;
            }
        },

        validarDataContrato(_, valor, mensagem) {
            if (valor > this.novosDados.dataVencimento) {
                return mensagem(
                    new Error(
                        'A data de vencimento não pode ser antes da data do contrato'
                    )
                );
            }
            return mensagem();
        },

        validarDataVencimento(_, valor, mensagem) {
            if (valor < this.novosDados.dataContrato) {
                return mensagem(
                    new Error(
                        'A data de vencimento não pode ser antes da data do contrato'
                    )
                );
            }
            return mensagem();
        },

        async buscarFornecedores(searchText) {
            this.buscandoFornecedores = true;
            const { data } = await RepresentanteService.findAllByFiltro({
                page: 0,
                size: 5,
                order: '',
                searchText
            });

            this.fornecedores = sortBy(
                data.resultados.map(
                    ({ id, cpfCnpj: documento, nomeRazaoSocial: nome }) => ({
                        id,
                        documento:
                            formatters.numeralStringFormatToDocumento(
                                documento
                            ),
                        nome
                    })
                ),
                ['nome']
            );
            this.buscandoFornecedores = false;
        },

        async salvarEdicao() {
            this.$refs.formEditarOperacaoCdaWa.validate(async valido => {
                if (valido) {
                    const {
                        id,
                        identificador,
                        descricao,
                        dataContrato,
                        dataVencimento,
                        idFornecedor,
                        idSafra,
                        idCultura,
                        volumeContratado,
                        nomeArmazem,
                        documentoArmazem,
                        valor,
                        observacao
                    } = this.novosDados;

                    const bodyAtualizacao = {
                        identificador,
                        descricao,
                        dataContrato: dataContrato.toLocaleDateString('pt-BR'),
                        dataVencimento: dataVencimento.toLocaleDateString('pt-BR'),
                        idFornecedor,
                        idSafra,
                        idCultura,
                        volumeContratado: parseFloat(volumeContratado.replace(',', '.')),
                        nomeArmazem,
                        documentoArmazem,
                        valor: parseFloat(valor.replace(',', '.')),
                        observacao
                    };

                    await OperacaoCdaWaService.editar(id, bodyAtualizacao);
                    this.$emit('operacaoAtualizada');
                    this.fechar();
                } else {
                    return false;
                }
            });
        }
    }
};
</script>

<style lang="scss">
#modal-editar-operacao-cda-wa {
    .modal-editar-operacao-cda-wa--linha {
        display: flex;
        gap: 8px;
        margin-bottom: 12px;

        .el-form-item {
            flex: 1;

            .el-date-editor.el-input,
            .el-date-editor.el-input__inner {
                width: 100%;
            }
        }

        .el-select {
            width: 100%;
        }
    }
}
</style>
